import React from "react";

import * as styles from "./ScreenReaderHeading.module.css";

type ScreenReaderHeadingProps = Readonly<{
  children: React.ReactNode;
}>;

export const ScreenReaderHeading = ({ children }: ScreenReaderHeadingProps) => (
  <h1 className={styles.heading}>{children}</h1>
);
